import React, { useState } from "react";
import { motion } from "framer-motion";
import { Box, Typography } from "@mui/material";
import Grid from '../image/grid-bs.png'
import SolarPanel from '../image/solarpanel-bs.png'
import Load from '../image/load-bs.png'
import Batery from '../image/battery-bs.png'
import Inverter from '../image/inverter-bs.png'
import colors from "../colour";
import { keyframes } from '@emotion/react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';


const colorPulse = keyframes`
  0% { background-color: ${colors.bs6}; }
  50% { background-color: #4dabf5; } // Example alternate color (light blue)
  100% { background-color: ${colors.bs6}; }
`;
// Arrow animation for solarpanel
const moveArrowLShape = keyframes`
  0% {
    transform: translate(0, 0) rotate(90deg);  /* Facing down */
    opacity: 1;
  }
  40% {
    transform: translate(0, 13.3vh) rotate(90deg);  /* Still facing down */
  }
  41% {
    transform: translate(0, 13.3vh) rotate(0deg);  /* Rotate to face right */
  }
  100% {
    transform: translate(13vw, 13.3vh) rotate(0deg);  /* Moving right */
    opacity: 1;
  }
`;
// Arrow animation for grid
const moveArrowLeftToRight = keyframes`
  0% {
    transform: translateX(0);  // Start from the left of the line
    opacity: 1;
  }
  100% {
    transform: translateX(18vw);  
    opacity: 1;
  }
`;

// Arrow animation for battery
const moveArrowReverseLShape = keyframes`
  0% {
    transform: translate(0, 0) rotate(270deg);  // Start at the bottom of the vertical line
    opacity: 1;
  }
  40% {
    transform: translate(0, -13.3vh) rotate(270deg);  // Move up the vertical line
  }
  41% {
    transform: translate(0, -13.3vh) ;  // Rotate the arrow after reaching the top
  }
  100% {
    transform: translate(13vw, -13.3vh);  // Move to the end of the horizontal line
    opacity: 1;
  }
`;
// Arrow animation for load
const moveArrowLeftToRight_LOAD = keyframes`
  0% {
    transform: translateX(-13vw); /* Start at the left of the horizontal line */
    opacity: 1;
  }
  100% {
    transform: translateX(0vw); /* Move to the right of the horizontal line */
    opacity: 1;
  }
`;


const Test = () => {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                width: "100%",
                backgroundColor: "gray",
                position: "absolute",

            }}
        >
            {/* ---------------Inverter -------------------*/}
            <Box
                component="img"
                src={Inverter}
                alt="Inverter"
                sx={{
                    width: "12%",
                    height: "30%",
                    objectFit: "cover",
                    position: "absolute",
                    top: "35%",
                    right: "40%",
                    zIndex: 2,
                }}
            />

            {/* SolarPanel */}
            <Box>
                <Box
                    sx={{
                        width: "11%",
                        height: "13%",
                        objectFit: "cover",
                        position: "absolute",
                        border: "0.3vh solid",
                        borderColor: colors.bs6,
                        top: "16.5%",
                        left: "39%",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                    }}
                >
                    <Typography sx={{ color: colors.bsf1, fontSize: "0.8vw" }}>Solar Generation : </Typography>
                </Box>
                <Box
                    component="img"
                    src={SolarPanel}
                    alt="SolarPanel"
                    sx={{
                        width: "8%",
                        height: "20%",
                        objectFit: "cover",
                        position: "absolute",
                        top: "12%",
                        left: "29%",
                    }}
                />
                {/* solar panel (from midway down to Inverter) */}
                {/* Vertical line (solar panel) */}
                <Box
                    sx={{
                        position: "absolute",
                        width: "0.1vw",
                        height: "13.3vh",
                        backgroundColor: colors.bs6,
                        animation: `${colorPulse} 2s infinite ease-in-out`,
                        top: "32.5%",
                        left: "33%",
                        zIndex: 1,
                    }}
                />

                {/* Horizontal line */}
                <Box
                    sx={{
                        position: "absolute",
                        width: "13.5vw",
                        height: "0.2vh",
                        backgroundColor: colors.bs6,
                        animation: `${colorPulse} 2s infinite ease-in-out`,
                        top: "47%",
                        left: "33%",
                        zIndex: 1,
                    }}
                />

                {/* Animated Arrow following L-path */}
                <PlayArrowIcon
                    sx={{
                        position: "absolute",
                        top: "calc(32.4% - 1vw)",  // Adjust vertical position (adjust this value for better centering)
                        left: "calc(33.25% - 1.2vw)", // Adjust horizontal position for better centering
                        color: colors.bsf1,
                        fontSize: "2vw",
                        animation: `${moveArrowLShape} 3s infinite linear`,  // Adjusted duration to match the other arrow
                        transformOrigin: "center center",  // Ensures rotation stays consistent
                        zIndex: 2,
                    }}
                />


            </Box>

            {/* ------------------Load-------------------- */}
            <Box>
                <Box
                    sx={{
                        width: "11%",
                        height: "13%",
                        objectFit: "cover",
                        position: "absolute",
                        border: "0.3vh solid",
                        borderColor: colors.bs6,
                        bottom: "25%",
                        right: "14%",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                    }}
                >
                    <Typography sx={{ color: colors.bsf1, fontSize: "0.8vw" }}>Actual Load : </Typography>
                </Box>
                <Box
                    component="img"
                    src={Load}
                    alt="Load"
                    sx={{
                        width: "10%",
                        height: "25%",
                        objectFit: "cover",
                        position: "absolute",
                        top: "35%",
                        right: "15%",
                    }}
                />
                <Box
                    sx={{
                        position: "absolute",
                        width: "14vw",
                        height: "0.2vh",
                        backgroundColor: colors.bs6,
                        animation: `${colorPulse} 2s infinite ease-in-out`,
                        top: "50%",
                        right: "25.5%",
                        zIndex: 1,
                    }}
                />
                <PlayArrowIcon
                    sx={{
                        position: "absolute",
                        top: "calc(50.1% - 1vw)",  // Adjust to center vertically with the line
                        right: "25.5%",  // Start from the left of the line
                        color: colors.bsf1,
                        fontSize: "2vw",
                        animation: `${moveArrowLeftToRight_LOAD} 3s infinite linear`,  // Animate from left to right
                        zIndex: 2,
                    }}
                />
            </Box>

            {/* ------------------ Battery ----------------------*/}
            <Box>
                <Box
                    sx={{
                        width: "11%",
                        height: "13%",
                        objectFit: "cover",
                        position: "absolute",
                        border: "0.3vh solid",
                        borderColor: colors.bs6,
                        bottom: "15.5%",
                        left: "39%",
                        justifyContent: "center",
                        display: "flex",
                        flexDirection: "column",
                        paddingLeft: "1vw",
                        gap: "2vh",
                    }}
                >
                    <Typography sx={{ color: colors.bsf1, fontSize: "0.7vw" }}>Battery SOC : </Typography>
                    <Typography sx={{ color: colors.bsf1, fontSize: "0.7vw" }}>Battery POWER : </Typography>
                </Box>
                <Box
                    component="img"
                    src={Batery}
                    alt="Battery"
                    sx={{
                        width: "8%",
                        height: "20%",
                        objectFit: "cover",
                        position: "absolute",
                        bottom: "12%",
                        left: "29%",
                    }}
                />
                {/* battery (from midway down to Inverter) */}
                <Box
                    sx={{
                        position: "absolute",
                        width: "0.1vw",
                        height: "13.3vh",
                        backgroundColor: colors.bs6,
                        animation: `${colorPulse} 2s infinite ease-in-out`,
                        bottom: "32.4%",
                        left: "33%",
                        zIndex: 1,
                    }}
                />
                <Box
                    sx={{
                        position: "absolute",
                        width: "13.5vw",
                        height: "0.2vh",
                        backgroundColor: colors.bs6,
                        animation: `${colorPulse} 2s infinite ease-in-out`,
                        bottom: "47%",
                        left: "33%",
                        zIndex: 1,
                    }}
                />
                {/* Animated Arrow Following Reverse L-Path (Bottom to Top, then Left to Right) */}
                <PlayArrowIcon
                    sx={{
                        position: "absolute",
                        bottom: "calc(32.3% - 1vw)",  // Adjust vertical position for bottom of vertical line
                        left: "calc(33.25% - 1.2vw)",  // Adjust horizontal position for centering
                        color: colors.bsf1,
                        fontSize: "2vw",
                        animation: `${moveArrowReverseLShape} 3s infinite linear`,  // Same duration as the other arrows for synchronization
                        transformOrigin: "center center",  // Ensures rotation stays consistent
                        zIndex: 2,
                    }}
                />
            </Box>

            {/* -----------GRID --------------*/}
            <Box>
                <Box
                    sx={{
                        width: "11%",
                        height: "13%",
                        objectFit: "cover",
                        position: "absolute",
                        border: "0.3vh solid",
                        borderColor: colors.bs6,
                        top: "43.5%",
                        left: "4%",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                    }}
                >
                    <Typography sx={{ color: colors.bsf1, fontSize: "0.8vw" }}>Incoming Grid : </Typography>
                </Box>
                <Box
                    component="img"
                    src={Grid}
                    alt="Grid"
                    sx={{
                        width: "8%",
                        height: "20%",
                        objectFit: "cover",
                        position: "absolute",
                        top: "40%",
                        left: "16%",
                    }}
                />
                <Box
                    sx={{
                        position: "absolute",
                        width: "20.7vw",
                        height: "0.2vh",
                        backgroundColor: colors.bs6,
                        animation: `${colorPulse} 2s infinite ease-in-out`,
                        top: "50%",
                        left: "25%",
                        zIndex: 1,
                    }}
                />
                <PlayArrowIcon
                    sx={{
                        position: "absolute",
                        top: "calc(50.1% - 1vw)",  // Adjust vertically to center the arrow on the line
                        left: "calc(25.5% + 0.5vw)",  // Starting from the left edge of the line
                        color: colors.bsf1,
                        fontSize: "2vw",
                        animation: `${moveArrowLeftToRight} 3s infinite linear`,  // Adjusted duration to match the other arrow
                        zIndex: 2,
                    }}
                />
            </Box>

        </Box>


    );
};

export default Test;
